import { NavigateOptions, useNavigate } from "react-router-dom"

import { useEvent } from "shared/lib/useEvent"
import { useLocale } from "shared/lib/useLocale"

export function useNavigateToPermalink(permalink: string): {
  navigate: () => void
  href: string
}
export function useNavigateToPermalink(): {
  navigate: (href: string, options?: NavigateOptions) => void
}
export function useNavigateToPermalink<T extends string | null>(permalink?: T) {
  const navigate = useNavigate()
  const { currentLocale } = useLocale()
  const href = `/${currentLocale}/${permalink}`
  const handleNavigate = useEvent(
    (parameterPermalink?: string, options?: NavigateOptions) => {
      const resolvedPermalink = permalink || parameterPermalink
      navigate(`/${currentLocale}/${resolvedPermalink}`, options)
    }
  )

  return { navigate: handleNavigate, href }
}
